export default {
	properties: [
		{
			text: 'Nombre',
			key: 'name',
			type: 'text',
			is_title: true,
		},
	],
	singular_model_name_spanish: 'Categoria de Gasto',
	plural_model_name_spanish: 'Categorias de Gasto',
	create_model_name_spanish: 'Nueva Categoria de Gasto',
	text_delete: 'la',
}